// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Grid,
  Card,
  Fab,
  Typography,
  Box,
  Container,
  Button,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

/* -----------------Icons--------------- */
import {
  AlertOutline,
  Calendar,
  PencilOutline,
  Cellphone,
  ChartBellCurveCumulative,
  Brain,
} from 'mdi-material-ui';

import {
  store,
  key,
} from '../../common/authutils';

/* -----------------Utils--------------- */
import {
  getContentIcon,
  getSmartFolderIcon,
} from '../../common/utils';
import { trackEvent } from '../../analytics/tracking';

/* -----------------Styles--------------- */
const styles = theme => ({
  card: {
    width: '100%',
  },
  alertIcon: {
    fontSize: 32,
    color: theme.palette.error.main,
  },
  brainIcon: {
    fontSize: 32,
    color: theme.palette.secondary.main,
  },
  fabFullSize: {
    width: 256,
    maxWidth: '100%',
  },
});

/* -----------------Type declarations--------------- */
type Classes = {
  card: string,
  alertIcon: string,
  brainIcon: string,
  fabFullSize: string
}

/* -----------------Props--------------- */
type Props = {
  classes: Classes,
  callback: () => void,
  cta: string,
  variant: 'default' | 'demo',
  redirectUrl: string
}

/* -----------------Component--------------- */
const CardGuestUserRegister = (props: Props) => {
  const {
    classes,
    callback,
    redirectUrl,
    variant = 'default',
    cta = 'Don\'t lose your progress!',
  } = props;

  const getFeatures = () => {
    if (variant === 'demo') {
      return [{
        label: 'Ace your exams with this Study-Pack',
        icon: getSmartFolderIcon('Study-Packs'),
      },
      {
        label: 'Authored by experts, updated weekly',
        icon: <PencilOutline />,
      },
      {
        label: 'Save time with spaced repetition',
        icon: <Calendar />,

      }, {
        label: 'Track your detailed progress',
        icon: <ChartBellCurveCumulative />,

      }, {
        label: 'Study everywhere with mobile apps',
        icon: <Cellphone />,

      }, {
        label: 'Create and collab on flashcards',
        icon: getContentIcon('STUDY_SET'),
      }];
    }
    return [{
      label: 'Study millions of free study sets',
      icon: getContentIcon('STUDY_SET'),
    }, {
      label: 'Save time with spaced repetition',
      icon: <Calendar />,

    }, {
      label: 'Create and collab on flashcards',
      icon: <PencilOutline />,

    }, {
      label: 'Ace exams with Study-Packs',
      icon: getSmartFolderIcon('Study-Packs'),

    }, {
      label: 'Track your detailed progress',
      icon: <ChartBellCurveCumulative />,

    }, {
      label: 'Study everywhere with free apps',
      icon: <Cellphone />,

    }];
  };

  const features = getFeatures();

  // TODO: This seems hard coded for demo - shouldn't it be specific to demo vs. unauth?
  const handleRedirectURL = () => {
    trackEvent('Guest session card FAB clicked');
    store(key.redirectUrl, redirectUrl);
  };

  const handleRedirectURLDemo = () => {
    trackEvent('Demo session card FAB clicked');
  };

  const iconCta = variant === 'demo' ? <Brain className={classes.brainIcon} /> : <AlertOutline className={classes.alertIcon} />;
  const FAB = () => {
    const ctaFab = variant === 'demo' ? 'Back to Study-Pack' : 'Create free account';
    const href = variant === 'demo' ? redirectUrl : '/create-account';
    return (
      <Fab
        size="large"
        color="primary"
        variant="extended"
        elevation={8}
        onClick={variant === 'demo' ? handleRedirectURLDemo : handleRedirectURL}
        href={href}
        classes={{
          extended: classes.fabFullSize,
        }}
      >
        {ctaFab}
      </Fab>
    );
  };

  const ButtonCloseSession = () => (
    <Grid
      item
      justifyContent="center"
      spacing={2}
      alignItems="center"
      container
      xs={12}
    >
      <Button
        onClick={callback}
        color="default"
        variant="outlined"
        classes={{ root: classes.fabFullSize }}
      >
        CLOSE SESSION
      </Button>
    </Grid>
  );

  const showButton = callback && variant !== 'demo';

  return (
    <Card elevation={24} classes={{ root: classes.card }}>
      <Container maxWidth="md">
        <Box py={6}>
          <Grid
            item
            container
            spacing={5}
            direction="column"
            alignItems="center"
          >
            <Grid
              item
              xs={12}
              container
              direction="row"
              justifyContent="center"
              spacing={2}
            >
              <Grid item>
                {iconCta}
              </Grid>
              <Grid item>
                <Typography variant="h6" align="center">
                  {cta}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FAB />
            </Grid>
            {showButton ? <ButtonCloseSession /> : null }
            <Grid
              item
              justifyContent="center"
              spacing={2}
              alignItems="center"
              container
              xs={12}
            >
              {features.map(({
                label,
                icon,
              }) => (
                <Grid
                  item
                  container
                  spacing={1}
                  key={label}
                  alignItems="center"
                  style={{ width: 300 }}
                >
                  <Grid item>
                    <Box color="secondary.main">
                      {icon}
                    </Box>
                  </Grid>
                  <Grid item>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                    >
                      {label}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Card>
  );
};

export default withStyles(styles)(CardGuestUserRegister);
